<template>
    <section class="mt-40 md:mt-10 md:py-28 py-14 xl:mt-0">
        <div class="max-w-screen-xl px-4 mx-auto sm:px-8">
            <div class="max-w-screen-lg mx-auto lg:px-4">
                <h3 class="mx-auto font-bold text-center title-mushroom font-ww-medium text-lifeboost-gray-lighter" v-html="mainHeading">
                </h3>

                <div class="mx-auto mt-8 text-center lg:mt-12 text-28 leading-38 text-balance text-lifeboost-gray-lighter font-ww-regular" v-html="subHeading">
                </div>
            </div>

            <div class="grid grid-cols-12 mt-20 md:grid-cols-10 md:mt-32 md:gap-y-28 gap-y-20">
                <div :class="index === 5 ? 'md:!col-start-3' : ''"
                    class="flex flex-col items-center col-span-6 md:col-span-2 gap-y-8" v-for="(item, index) in items"
                    :key="index">
                    <div
                        class="h-24 w-24 bg-[#f3efed] rounded-full border border-solid  flex items-center justify-center">
                        <nuxt-img :src="item.imgSrc" :alt="item.imgAlt"
                            :width="item.width" :height="item.height" format="webp" loading="lazy"></nuxt-img>
                    </div>
                    <div class="text-xl leading-none text-center text-lifeboost-gray-lighter md-max:leading-8 font-ww-regular sm:text-28 text-25 md:text-26 lg:text-28" v-html="item.text">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>

const props = defineProps({
    mainHeading: {
        type: String,
        default: 'The Highest Quality High-Potency, Real Mushroom Extracts'
    },
    subHeading: {
        type: String,
        default: '100% Real Mushrooms Combined with Low Acid, USDA Certified Organic Coffee Tested for Over 450 Toxins'
    },
    items: {
        type: Array,
        default: () => [
            {
                text: "USDA <br> Organic",
                imgSrc: '/assets/images/icon-m-1.png',
                imgAlt: 'USDA Organic Icon',
                width: '67',
                height: '67'
            },
            {
                text: "Toxin-Free",
                imgSrc: '/assets/images/icon-m-2.png',
                imgAlt: 'Toxin-Free Icon',
                width: '48',
                height: '56'
            },
            {
                text: "Shade <br> Grown",
                imgSrc: '/assets/images/icon-m-3.png',
                imgAlt: 'Shade Grown Icon',
                width: '59',
                height: '48'
            },
            {
                text: "Single <br> Origin",
                imgSrc: '/assets/images/icon-m-4.png',
                imgAlt: 'Single Origin Icon',
                width: '48',
                height: '58'
            },
            {
                text: "Sun Dried",
                imgSrc: '/assets/images/icon-m-5.png',
                imgAlt: 'Sun Dried Icon',
                width: '53',
                height: '53'
            },
            {
                text: "Hand-Picked",
                imgSrc: '/assets/images/icon-m-6.png',
                imgAlt: 'Hand-Picked Icon',
                width: '58',
                height: '61'
            },
            {
                text: "Hand-Washed",
                imgSrc: '/assets/images/icon-m-7.png',
                imgAlt: 'Hand-Washed Icon',
                width: '45',
                height: '53'
            },
            {
                text: "High Elevation <br> Grown",
                imgSrc: '/assets/images/icon-m-8.png',
                imgAlt: 'High Elevation Grown Icon',
                width: '43',
                height: '53'
            },
        ]
    },
});

defineBuilderComponent({
    friendlyName: "Ttitle Description Icons",
    inputs: [
        {
            name: "mainHeading",
            type: "richText",
            friendlyName: "Main Heading",
            defaultValue: "The Highest Quality High-Potency, Real Mushroom Extracts"
        },
        {
            name: "subHeading",
            type: "richText",
            friendlyName: "Sub Heading",
            defaultValue: "100% Real Mushrooms Combined with Low Acid, USDA Certified Organic Coffee Tested for Over 450 Toxins"
        },
        {
            name: "items",
            type: "list",
            friendlyName: "Items List",
            subFields: [
                {
                    name: "text",
                    type: "richText",
                    friendlyName: "Item Text",
                    defaultValue: ""
                },
                {
                    name: "imgSrc",
                    type: "file",
                    friendlyName: "Image Source",
                    allowedFileTypes: ["jpeg", "jpg", "png", "webp"],
                    defaultValue: ""
                },
                {
                    name: "imgAlt",
                    type: "string",
                    friendlyName: "Image Alt Text",
                    defaultValue: ""
                },
                {
                    name: "width",
                    type: "string",
                    friendlyName: "Image Width",
                    defaultValue: ""
                },
                {
                    name: "height",
                    type: "string",
                    friendlyName: "Image Height",
                    defaultValue: ""
                }
            ],
            defaultValue: [
                {
                    text: "USDA <br> Organic",
                    imgSrc: "/assets/images/icon-m-1.png",
                    imgAlt: "USDA Organic Icon",
                    width: "67",
                    height: "67"
                },
                {
                    text: "Toxin-Free",
                    imgSrc: "/assets/images/icon-m-2.png",
                    imgAlt: "Toxin-Free Icon",
                    width: "48",
                    height: "56"
                },
                {
                    text: "Shade <br> Grown",
                    imgSrc: "/assets/images/icon-m-3.png",
                    imgAlt: "Shade Grown Icon",
                    width: "59",
                    height: "48"
                },
                {
                    text: "Single <br> Origin",
                    imgSrc: "/assets/images/icon-m-4.png",
                    imgAlt: "Single Origin Icon",
                    width: "48",
                    height: "58"
                },
                {
                    text: "Sun Dried",
                    imgSrc: "/assets/images/icon-m-5.png",
                    imgAlt: "Sun Dried Icon",
                    width: "53",
                    height: "53"
                },
                {
                    text: "Hand-Picked",
                    imgSrc: "/assets/images/icon-m-6.png",
                    imgAlt: "Hand-Picked Icon",
                    width: "58",
                    height: "61"
                },
                {
                    text: "Hand-Washed",
                    imgSrc: "/assets/images/icon-m-7.png",
                    imgAlt: "Hand-Washed Icon",
                    width: "45",
                    height: "53"
                },
                {
                    text: "High Elevation <br> Grown",
                    imgSrc: "/assets/images/icon-m-8.png",
                    imgAlt: "High Elevation Grown Icon",
                    width: "43",
                    height: "53"
                }
            ]
        }
    ]
});

</script>
